import React, { useEffect, useRef, useState } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import Styles from '../lib/Styles';
import APIService from '../shared/api-service';
import IMake from '../shared/IMake';
import classes from './SelectField.module.scss';
import { TextWithTooltip } from './TextWithTooltip';

export default function SelectMakes(props: any) {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [makes, setMakes] = useState<Array<IMake>>([]);
  const [errorLoadingMakes, setErrorLoadingMakes] = useState<string>('')
  const {selectedMakes, setSelectedMakes, onChangeMakes, readOnly } = props;
  let initialValue = useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  useEffect(() => {
    const itemService = new APIService();
    itemService.retrieveMakes().then((makes: void | Array<IMake>) => {
      if (makes) {
        setErrorLoadingMakes('');
        setMakes(makes);
        if (initialValue.current) {
          initialValue.current = initialValue.current.replace(/Highland Ridge Rv, Inc./gi, "Highland Ridge Rv<comma> Inc.");
          initialValue.current = initialValue.current.replace(/Little Guy Worldwide, Llc/gi, "Little Guy Worldwide<comma> Llc");
          initialValue.current = initialValue.current.replace(/Vanleigh Rv, Inc./gi, "Vanleigh Rv<comma> Inc.");
          let mks: Array<string> = initialValue.current.split(',').map((item: string) => item.trim());
          mks = mks.map((item: string) => item.replace(/<comma>/gi, ","));
          let selectedMks: Array<IMake> = new Array<IMake>();
          for (let i = 0; i < mks.length; i++) {
            let mk = mks[i];
            const index = makes.findIndex((item: IMake) => item.Name === mk);
            if (index >= 0) {
              selectedMks.push(makes[index]);
            }
          }
          setSelectedMakes(selectedMks);
          initialValue.current = undefined;
        }
      }
      setLoaded(true);
    })
    .catch((reason) => {
      setErrorLoadingMakes(reason.message);
    })
  }, [setSelectedMakes]);

  return (
    <div>
      <div className={cx('root')}>
      <Autocomplete
        disabled={readOnly || (!makes || makes.length === 0)}
        multiple
        options={makes}
        getOptionLabel={(option: any) => option.Name}
        defaultValue={undefined}
        value={selectedMakes}
        filterSelectedOptions
        onChange={onChangeSelectedMakes}

        renderInput={(params: any) => (
          <TextField
            {...params}
            variant="outlined"
            label={!loaded ? "Loading Makes ..." : "Makes"}
            error={!!errorLoadingMakes}
            helperText={!!errorLoadingMakes ? (<TextWithTooltip text={'Unable to load list of makes from server.'} tip={errorLoadingMakes}/>) : ''}
            placeholder={"Select one or more makes."}
            fullWidth
            required={true}
          />
        )}
      />
    </div>
    </div>
  );

  function onChangeSelectedMakes(event: any, values: any) {
    setSelectedMakes(values);
    onChangeMakes();
  }
}
